import { checkAPIResponse } from "../../../Utils/APIResponseUtils";
import apiService from "../../../Services/APIService";
import store from "../../../Store/Store";

export const getEmailConfigurationData = async () => {
    const state = store.getState();
    const masterData = state.masterData
    return {
        OwnEmail: masterData.ownEmail[0],
        OwnEmailPwd: masterData.ownEmailPwd[0]
    }
}

export const addEmailConfigurationData = async (configurationData, key) => {
    const payload = {
        changeType: "MASTER",
        key: key,
        value: '',
        values: JSON.stringify(configurationData)
    }

    try {
        const result = await apiService.sendChange(3, 'set', payload);
        checkAPIResponse(result);
        return result;
    }
    catch (error) {
        throw error;
    }
}

// Function which will set a google review link to database
export const setGoogleReviewLink = async (configurationData, key) => {
    const payload = {
        changeType: "MASTER",
        key: key,
        value: configurationData,
        values: '[]'
    }

    try {
        const result = await apiService.sendChange(3, 'set', payload);
        checkAPIResponse(result);
        return result;
    }
    catch (error) {
        throw error;
    }
}

export const getGoogleReviewLink = () => {
    const state = store.getState();
    const masterData = state.masterData
    return masterData?.googleReviewLink[0]
}

// OAuth Gmail Link - Get Authorization URL
export const getGmailAuthUrl = async () => {
    const payload = {}; // Empty payload for GET operation

    try {
        const result = await apiService.getData(3, 'getAuthUrl', payload);
        return result;
    }
    catch (error) {
        throw error;
    }
}

// OAuth Gmail Link - Save Tokens (STAYS IN SET)
export const saveGmailOAuthTokens = async (code) => {
    const payload = {
        changeType: "OAUTH",
        key: "SAVETOKEN",
        value: code,
        values: '[]'
    }

    try {
        const result = await apiService.sendChange(3, 'set', payload);
        return result
    }
    catch (error) {
        throw error;
    }
}

// Check if OAuth is configured
export const checkOAuthStatus = () => {
    const state = store.getState();
    const masterData = state.masterData;
    return {
        isOAuthEnabled: masterData?.isOAuthEnabled?.[0] || false,
        oauthEmail: masterData?.ownEmail?.[0] || ''
    }
}

export const unlinkGmailAccount = async () => {
    const payload = {
        changeType: "OAUTH",
        key: "UNLINKACCT",
        value: '',
        values: '[]'
    }

    try {
        const result = await apiService.sendChange(3, 'set', payload);
        return result
    }
    catch (error) {
        throw error;
    }
}

// Set Inquiry Duplication (1 = Allow, 0 = Don't Allow)
export const setInquiryDuplication = async (value) => {
    const payload = {
        changeType: "MASTER",
        key: "INQDUP",
        value: value,
        values: '[]'
    }

    try {
        const result = await apiService.sendChange(3, 'set', payload);
        checkAPIResponse(result);
        return result;
    }
    catch (error) {
        throw error;
    }
}

// Set Preferred Language for Recording/Transcription
export const setPreferredLanguage = async (language) => {
    const payload = {
        changeType: "MASTER",
        key: "PREFLANG",
        value: language,
        values: '[]'
    };

    try {
        const result = await apiService.sendChange(3, 'set', payload);
        checkAPIResponse(result);
        return result;
    } catch (error) {
        throw error;
    }
};